import styled from 'styled-components'

// The spinner a list body shows while loading. Every other state of that body
// reserves at least this height, so the card keeps its size when loading
// finishes and the rows or the empty text take the spinner's place
export const LIST_SPINNER_SIZE = 32

type Props = {
  $center?: boolean
}

export default styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: ${({ $center }) => ($center ? 'center' : 'flex-start')};
  gap: 12px;
  min-height: ${LIST_SPINNER_SIZE}px;
  padding: 10px 0;
`
